import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueCreateRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-create',
	path: '(/secure/|/)CreateIssue(\\w*)([!%]?[\\w]*).jspa',
};
